
const REDIRECT_URI = `https://${location.host}/auth/complete.php`;
const URISendState = `https://${location.host}/auth/front.php?state=`;
const clientId = 'tid_cloudpayments-wl';



function decodeState(state) {
	return atob(state);
}
function JSONifyState(string) {
	return JSON.parse(string);
}
function getState() {
	let params = new URLSearchParams(document.location.search);
	return params.get('state');
}
function getJsonState(string) {
	let decodedString = decodeState(string);
	return JSONifyState(decodedString);
}


function generateState(token) {
	const form = {
		token: token,
	}

	let stateFromURL = getState();

	if (stateFromURL) {
		let JsonState = getJsonState(stateFromURL);
	}

	if (!JSON.parse(localStorage.getItem('form'))?.auth) {
		localStorage.setItem('form', JSON.stringify(form));
	}
}
function generateToken(length) {
	let a = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'.split('');
	let b = [];
	for (let i = 0; i < length; i++) {
		let j = (Math.random() * (a.length - 1)).toFixed(0);
		b[i] = a[j];
	}
	return b.join('');
}


function init() {
	if (document.querySelector('#request-simple') && document.querySelector('#request-simple').querySelector('input[name="page"]')) {
		if (
			// document.querySelector('#request-simple').querySelector('input[name="page"]').value !== 'tips' &&
			// document.querySelector('#request-simple').querySelector('input[name="page"]').value !== 'cloud-cheki' &&
			document.querySelector('#request-simple').querySelector('input[name="page"]').value !== 'not-resident'
		) {
			let TOKEN = generateToken(30);
			generateState(TOKEN);
			const tidSdk = new TidSDK({
				redirectUri: REDIRECT_URI,
				responseType: 'code',
				clientId: clientId,
				state: TOKEN
			});
			if (document.querySelector('#request-simple').querySelector('input[name="page"]').value !== 'agents') {
				tidSdk.addWL({
					target: '_self',
					input: '#phoneResident',
					actionElement: '#request-simple'
				});
				window.whiteLabel = tidSdk;
			} else {
				tidSdk.addWL({
					target: '_self',
					input: '#phoneNoResident',
					actionElement: '#request-simple'
				});
				window.whiteLabel = tidSdk;
			}


		} else {
			localStorage.removeItem('form');
		}
	}
}

export default {
	init,
};
